export class VisitorCreateEventCommand {
    public name: string;
    public description: string;
    public host: string;
    public venue: string;
    public category: string;
    public startTime: Date;
    public endTime: Date;
    public startTimeText: string;
    public endTimeText: string;
    public timezone: string;
    public image: File;
    public eventTimes = [];
    public eventTimesText: string;
    public address: {
        lat: number,
        lng: number,
        address: string
    };
    public defaultImage: string;
    public ticketUri: string;
    public isHubCreated: boolean;
    public isFacebookEvent: boolean;
    public hostLink: string;
    public eventLink: string;
    public imageLink: string;
    public frequency: string;
    public organizerEmail: string;
    public isOnlineEvent: boolean;
    public isHybridEvent: boolean;
}


// WEBPACK FOOTER //
// D:/Work/Development/vsts_build/_work/2/s/web/src/commands/visitor/event/create.event.command.ts